import * as React from 'react';
import { ApplicationPageState } from '../../../containers/application/states/ApplicationPageState';
import { inject, observer } from 'mobx-react';
import { Page, Pane, PaneBackButton, PaneBody, PaneHeader } from '../../atoms/applications/page';
import { CalendarView } from '../../molecules/calendar/CalendarView';
import moment from 'moment-timezone';
import { observable, makeObservable } from 'mobx';
import { StartDateSummary } from '../../atoms/applications/StartDateSummary';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import './startDateSelectionPane.module.scss';
import PaymentScheduleImageSp from './images/payment-schedule-image-sp.png';

type Props = {
  applicationState: ApplicationPageState;
};

export const StartDateSelectionPane = inject('applicationState')(
  observer(
    class StartDateSelectionPane extends React.Component<Props> {
      selectionStartDate: moment.Moment = moment();
      selectionEndDate: moment.Moment = moment().add(2, 'month');
      selectableDate: moment.Moment[] = [];
      init = false;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          selectionStartDate: observable,
          selectionEndDate: observable,
          selectableDate: observable,
          init: observable,
        });
      }

      componentDidMount(): void {
        this.selectionStartDate = moment();
        this.selectionEndDate = moment().add(2, 'month');
        this.selectableDate = [];
        for (
          let currentDate = moment(this.selectionStartDate);
          currentDate.isBefore(this.selectionEndDate);
          currentDate = moment(currentDate).add(1, 'day')
        ) {
          this.selectableDate.push(currentDate);
        }
        this.init = true;
      }

      render() {
        const { canGoBack, startDate, setStartDate, validateStartDateAndNext } = this.props.applicationState;
        if (!this.init) {
          return null;
        }
        return (
          <Page>
            <Pane styleName="pane">
              {canGoBack && <PaneBackButton />}
              <PaneHeader>SHElikesを開始する日を決めましょう</PaneHeader>
              <PaneBody>
                <div styleName="lead-text">選択した日からプランの適用が開始されます</div>
                {GlobalStatesV3.viewport.isSp && (
                  <div styleName="payment-schedule-image">
                    <img src={PaymentScheduleImageSp} alt="" />
                  </div>
                )}
                <div styleName="body">
                  <div styleName="calendar">
                    <CalendarView
                      startDate={this.selectionStartDate}
                      endDate={this.selectionEndDate}
                      selectedDate={startDate}
                      clickables={this.selectableDate}
                      onClick={setStartDate}
                      onMonthChange={() => null}
                    />
                  </div>
                  <StartDateSummary date={startDate} onSubmit={validateStartDateAndNext} />
                </div>
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
